<template>
  <div class="page-container">
    <div class="query-title">存新酒储存单查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="导出数据" @click="exportExcel" />
            <table-button name="export" tip="调整期限" @click="handleData" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          />
        </Table-filter>
      </div>
    </div>
    <el-dialog
      v-dialogDrag
      title="调整储存期限"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <vxe-grid
            ref="yTable"
            v-loading="loading"
            class="table-block dialogTab"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridDialogOptions.columns"
            :data="gridDialogOptions.data"
            :row-class-name="rowClassName"
          >
          </vxe-grid>
          <el-form ref="form" :model="dialogForm" label-width="95px" class="dialogTab">
            <el-form-item label="储存期限(月)">
              <el-input v-model="dialogForm.savedMonths"></el-input>
            </el-form-item>
          </el-form>
      </template>

      <div slot="footer">
        <el-button type="default" icon="el-icon-circle-close" size="small" @click="showDialog = false">取消</el-button>
        <el-button type="primary" icon="el-icon-circle-check" size="small" @click="submitHandle">确定</el-button>
      </div>
    </el-dialog>
    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />
  </div>
</template>

<script>
import { findStorageSingle, adjustStorageTime} from '@/api/applyForGoods/index'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/newWineStoreList'
import { Message } from 'element-ui'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      dialogForm:{
        savedMonths: '',
      },
      loading: false,
      dialog: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      showDialog: false,
      gridDialogOptions: {
        border: false,
        highlightHoverRow: true,
        resizable: true,
        showOverflow: true,
        height: 'auto',
        maxHeight: '240',
        align: 'center',
        size: 'mini',
        emptyText: '暂时没数据',
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          {
            field: 'wantCode',
            title: '要货单号',
            width: 110
          },
          {
            field: 'customerName',
            title: '客户名称',
            width: 130
          },
          {
            field: 'planTypeTextView',
            title: '计划类型',
            width: 130
          },
          {
            field: 'saleCenterName',
            title: '营销单元',
            width: 130
          },
          {
            field: 'wantQuantity',
            title: '要货量',
            width: 100,
            xlsxFmt: {
              t: 'n'
            }
          },
          {
            field: 'createdDate',
            title: '创建日期',
            width: 140
          },
          {
            field: 'savedMonths',
            title: '存储期限(月)',
            width: 110
          },
          {
            field: 'billCode',
            title: '单据编号',
            width: 100
          }
        ],
        data: [],
        editConfig: { trigger: 'click', mode: 'cell' }
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', width: 50, field: 'checkbox' }
        ],
        data: []
      },
      pageSearch,
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.initPage(pageConfig)
    this.tableSort.push({ field_name: 'createdDate', field_sort: 'X' })
  },
  methods: {
    // 导出全部 导出本页
    async exportExcel() {
      const checkData = this.$refs.xTable.getCheckboxRecords()
      if (checkData.length) {
        frontExport(this.gridOptions.columns, checkData, '存新酒储存单报表')
        return
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, findStorageSingle)
      frontExport(this.gridOptions.columns, data, '存新酒储存单报表')
    },
    handleData(){
      const data = this.$refs.xTable.getCheckboxRecords()
      if(data.length){
        this.showDialog = true
        this.gridDialogOptions.data = data
      }
    },
    async submitHandle(){
      if(!this.dialogForm.savedMonths){
        return Message.warning('请填写储存期限')
      }
      const ids = []
      this.gridDialogOptions.data.forEach(ele => {
        ids.push({
          id:ele.id,
          savedMonths:this.dialogForm.savedMonths,
        })
      });
      const res = await adjustStorageTime(ids)
      if(res.status == 1){
        this.dialogForm.savedMonths = ''
        this.showDialog = false
        this.queryData()
      }else{
        return Message.warning(res.msg)
      }
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data: { Rows, Total }, calculation, field } = await findStorageSingle(params)
        if (Rows.length === 0 && Total) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = Total - 0
        this.calculation = this.filtercalculation(calculation, 'xTable', true)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(Rows)
        } else {
          this.gridOptions.data = Rows.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field, 'xTable', true)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped>
  .dialogTab{
    /deep/ .el-input{
      width: 200px;
      .el-input__inner{
        height: 30px;
      }
    }
    /deep/ .el-form-item__label{
      font-size: 14px;

    }
  }

</style>




// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/newWineStoreList.vue